module.exports = __webpack_public_path__ + "img/mv.5027047f.svg";